<template>
  <div class="uk-container">
    <themes-cover/>
    <themes-filter/>
  </div>
</template>

<script>
import ThemesCover from './ThemesCover'
import ThemesFilter from './ThemesFilter'

export default {
  components: {
    ThemesCover,
    ThemesFilter
  }
}
</script>
